<input
  class="pu-control__input pu-multi-select__input"
  readonly
  #inputRef
  #dropdownRef="puDropdownTrigger"
  [puDropdownTriggerFor]="selectDropdown"
  [reference]="inputRef"
  [id]="controlId"
  [ngClass]="{
    'pu-control__input_invalid': control.dirty && control.invalid,
    'pu-control__input_padding': !!tooltip,
    'pu-multi-select__input_focus': dropdownRef.isDropdownOpened$ | async,
    'pu-multi-select__input_readonly': isReadonly
  }"
  [placeholder]="placeholder"
  [formControl]="control"
  (opened)="selectOpened.emit()"
  [attr.data-testid]="controlTestId"
/>

<ng-container *ngIf="label">
  <label
    [for]="controlId"
    class="pu-control__label pu-control__label_active"
    [ngClass]="{
      'pu-control__label_invalid': control.dirty && control.invalid,
      'pu-control__label_small': labelSize === 's'
    }">
    {{ label }}
  </label>

  <pu-floating-label-outline
    [hasGap]="true"
    [label]="label"
    [labelSize]="labelSize"
    [isHighlighted]="dropdownRef.isDropdownOpened$ | async"
    [isInvalid]="control.dirty && control.invalid"
    [isReadOnly]="isReadonly">
  </pu-floating-label-outline>
</ng-container>

<ui-icon
  class="pu-multi-select__chevron"
  iconName="chevron-1"
  size="20"
  *ngIf="!isReadonly"
  [ngClass]="{ 'pu-multi-select__chevron_active': dropdownRef.isDropdownOpened$ | async,
  'pu-multi-select__chevron_tooltip': !!tooltip }">
</ui-icon>

<pu-control-tooltip
  class="pu-control__icon"
  *ngIf="tooltip"
  [tooltip]="tooltip"
  [reference]="inputRef">
</pu-control-tooltip>

<div class="pu-multi-select__selected-items"
     *ngIf="selected.length">

  <span *ngFor="let item of selected; let last = last; trackBy: trackById">
    {{ item[nameField] | translate }}<span *ngIf="!last">,&nbsp;</span>
  </span>
</div>

<span class="pu-control__hint"
      *ngIf="hint && !isReadonly"
      [class.pu-control__hint_invalid]="control.dirty && control.invalid">
  {{ hint }}
</span>

<pu-dropdown #selectDropdown>
  <div class="pu-multi-select__items">
    <div class="pu-multi-select__item-container"
         *ngFor="let item of items; trackBy: trackById"
         (click)="toggleItem($event, item)">

      <ui-icon
        class="pu-multi-select__icon-checkbox"
        iconName="checkbox-active"
        size="20"
        *ngIf="selectedIndex[item[valueField]]">
      </ui-icon>

      <ui-icon
        class="pu-multi-select__icon-checkbox"
        iconName="checkbox"
        size="20"
        *ngIf="!selectedIndex[item[valueField]]">
      </ui-icon>

      <ng-container
        *ngTemplateOutlet="itemTpl || defaultItemTpl; context: { $implicit: item, isSelected: !!selectedIndex[item[valueField]] }">
      </ng-container>
    </div>
  </div>
</pu-dropdown>

<ng-template
  #defaultItemTpl
  let-item
  let-isSelected="isSelected">
  <div class="pu-multi-select__default-item"
       [class.pu-multi-select_default-item-selected]="isSelected">
    {{ item.name }}
  </div>
</ng-template>
